import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import BrandMarquee from '../components/BrandMarquee';
import About from '../components/About';
import Services from '../components/Services';
import Inventory from '../components/Inventory';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const PublicSite = () => {
  return (
    <div className="App">
      <Navbar />
      <Hero />
      <BrandMarquee />
      <Inventory />
      <About />
      <Services />
      <Contact />
      <Footer />
    </div>
  );
};

export default PublicSite;
